import { render, staticRenderFns } from "./CreateSpace.vue?vue&type=template&id=72d7e3ce"
import script from "./CreateSpace.vue?vue&type=script&lang=js"
export * from "./CreateSpace.vue?vue&type=script&lang=js"
import style0 from "./CreateSpace.vue?vue&type=style&index=0&id=72d7e3ce&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports